import {ArrowBigRight, CheckCircle2, Clock} from 'lucide-react';
import {useNavigate} from "react-router-dom";
import {URLS} from "@/lib/urls";
import {sprintf} from "@/lib/utils/sprintf";

const ResultModal = ({totalQuestions, answeredQuestions, timeSpent, onRestart, result}) => {
    const minutes = Math.floor(timeSpent / 60);
    const seconds = timeSpent % 60;
    const completionPercentage = Math.round((answeredQuestions / totalQuestions) * 100);
    const navigate = useNavigate();

    return (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-4">
            <div
                className="bg-white dark:bg-slate-900 rounded-3xl shadow-2xl max-w-md w-full p-8 animate-in fade-in zoom-in duration-300"
                dir="rtl"
            >
                <div className="text-center">
                    <div
                        className="w-20 h-20 bg-gradient-to-br from-green-500 to-emerald-600 rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg"
                    >
                        <CheckCircle2 className="w-12 h-12 text-white"/>
                    </div>

                    <h2 className="text-3xl font-bold text-gray-900 dark:text-gray-100 mb-2">
                        آزمون پایان یافت!
                    </h2>
                    <p className="text-gray-600 dark:text-gray-400 mb-8">
                        نتایج شما به شرح زیر است:
                    </p>

                    <div className="space-y-4 mb-8">
                        <div
                            className="bg-gradient-to-l from-blue-50 to-cyan-50 dark:from-slate-800 dark:to-slate-800/80 rounded-2xl p-6 border border-blue-100 dark:border-slate-700"
                        >
                            <div className="flex items-center justify-between">
                                <span className="font-medium text-gray-700 dark:text-gray-300">
                                    سوالات پاسخ داده شده
                                </span>
                                <div className="flex items-center gap-2">
                                    <span className="text-3xl font-bold text-blue-600 dark:text-blue-400">
                                        {answeredQuestions}
                                    </span>
                                    <span className="text-gray-500 dark:text-gray-400">
                                        از {totalQuestions}
                                    </span>
                                </div>
                            </div>

                            <hr className="my-2 border-gray-200 dark:border-slate-700"/>

                            <div className="flex items-center justify-between">
                                <span className="font-medium text-gray-700 dark:text-gray-300">
                                    امتیاز شما
                                </span>
                                <div className="flex items-center gap-2">
                                    <span className="text-3xl font-bold text-blue-600 dark:text-blue-400">
                                        {result?.score}
                                    </span>
                                </div>
                            </div>

                            <div className="flex items-center justify-between">
                                <span className="font-medium text-gray-700 dark:text-gray-300">
                                    وضعیت قبولی
                                </span>
                                <div className="flex items-center gap-2">
                                    <span
                                        className={`text-3xl font-bold ${
                                            result?.win
                                                ? 'text-green-600 dark:text-green-400'
                                                : 'text-red-600 dark:text-red-400'
                                        }`}
                                    >
                                        {result?.win ? 'قبول' : 'مردود'}
                                    </span>
                                </div>
                            </div>

                            <div className="mt-3 h-2 bg-gray-200 dark:bg-slate-700 rounded-full overflow-hidden">
                                <div
                                    className="h-full bg-gradient-to-l from-blue-500 to-cyan-500 transition-all duration-1000"
                                    style={{width: `${completionPercentage}%`}}
                                />
                            </div>

                            <p className="text-sm text-gray-600 dark:text-gray-400 mt-2">
                                درصد پاسخ به سوالات: {completionPercentage}%
                            </p>
                        </div>

                        <div
                            className="bg-gradient-to-l from-green-50 to-emerald-50 dark:from-emerald-950/40 dark:to-green-950/30 rounded-2xl p-6 border border-green-100 dark:border-emerald-900/50"
                        >
                            <div className="flex items-center justify-between">
                                <div className="flex items-center gap-2">
                                    <Clock className="w-5 h-5 text-green-600 dark:text-green-400"/>
                                    <span className="font-medium text-gray-700 dark:text-gray-300">
                                        زمان صرف شده
                                    </span>
                                </div>
                                <span className="text-2xl font-bold text-green-600 dark:text-green-400 font-mono">
                                    {String(minutes).padStart(2, '0')}:{String(seconds).padStart(2, '0')}
                                </span>
                            </div>
                        </div>
                    </div>

                    <button
                        onClick={() => navigate(sprintf(URLS.student.lessons.myLesson.detail, {id: result?.takenunit_id}))}
                        className="w-full py-4 bg-gradient-to-l from-blue-600 to-cyan-600 dark:from-blue-500 dark:to-cyan-500 text-white rounded-xl font-bold text-lg hover:shadow-xl hover:scale-105 transition-all flex items-center justify-center gap-2"
                    >
                        <ArrowBigRight className="w-5 h-5"/>
                        بازگشت
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ResultModal;